import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import colors from 'styles/colors';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/system';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

const FullScreenDialog = ({
  onClose,
  title,
  children,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xl'));

  return (
    <Dialog
      open
      fullScreen={fullScreen}
      className="fullScreenDialog"
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h6" color={colors.text.primary}>
            {title}
          </Typography>
          <IconButton
            onClick={onClose}
            sx={{ paddingBottom: '3px' }}
          >
            <FullscreenExitIcon
              fontSize="small"
              sx={{
                color: colors.text.primary,
                '&:hover': {
                  color: colors.text.secondary,
                },
              }}
            />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default FullScreenDialog;
